var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useId } from '../../utils/use-id';
export var useDropdownMenuState = function (_a) {
    var propBaseId = _a.baseId;
    var baseId = useId(propBaseId);
    var triggerId = "".concat(baseId, "-trigger");
    var menuId = "".concat(baseId, "-menu");
    var _b = __read(React.useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleTriggerClick = function (event) {
        event.preventDefault();
        setAnchorEl(event.currentTarget);
    };
    var handleMenuClose = function () { return setAnchorEl(null); };
    var isOpen = !!anchorEl;
    return {
        triggerProps: {
            onClick: handleTriggerClick,
            id: triggerId,
            'aria-controls': menuId,
            'aria-haspopup': 'menu',
            'aria-expanded': isOpen,
        },
        menuProps: {
            anchorEl: anchorEl,
            open: isOpen,
            onClose: handleMenuClose,
            id: menuId,
        },
    };
};
export var DropdownMenuStateContext = React.createContext({
    triggerProps: { onClick: function () { return undefined; } },
    menuProps: { open: false },
});
export var useDropdownMenuStateContext = function () { return React.useContext(DropdownMenuStateContext); };
export var DropdownMenuStateProvider = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var state = useDropdownMenuState(props);
    return (React.createElement(DropdownMenuStateContext.Provider, { value: state }, typeof children === 'function' ? children(state) : children));
};
